module.exports = "import React from 'react';\nimport Slider from 'material-ui/Slider';\n\n/**\n * The `defaultValue` property sets the initial position of the slider.\n * The slider appearance changes when not at the starting position.\n */\nconst SliderExampleSimple = () => (\n  <div>\n    <Slider />\n    <Slider defaultValue={0.5} />\n    <Slider defaultValue={1} />\n  </div>\n);\n\nexport default SliderExampleSimple;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Slider/ExampleSimple.js
 ** module id = 1049
 ** module chunks = 0
 **/